import {ChangeDetectionStrategy, Component, Input, OnChanges} from '@angular/core';
import {StatusChipColor, StatusChipColors} from '@aviary/store/common/common.types';
import {MatChip} from '@angular/material/chips';
import {FormatPipe} from '@aviary/pipes/format.pipe';

@Component({
  selector: 'mx-status-chip',
  host: {
    class: 'flex flex-col items-center'
  },
  template: `
    <mat-chip [color]="color" class="mx-status-chip" [class.h-7]="hasSubscriptText">
      @if (useContent) {
        <ng-content/>
      } @else {
        {{ displayableStatus | format:'TITLE_CASE' }}
      }
    </mat-chip>

    @if (hasSubscriptText) {
      <span class="mx-status-chip-subscript text-label-small">{{ subscriptText }}</span>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatChip, FormatPipe]
})
export class StatusChipComponent<T extends string> implements OnChanges {

  @Input() status?: T | null;
  @Input({required: true}) colors: StatusChipColors<T>;
  @Input() displayableStatusNames: Map<T, string> = new Map();
  @Input() useContent?: boolean = false; // Until Angular can detect whether <ng-content> is populated, this is simple and reliable, though slightly annoying.
  @Input() subscriptText?: string;

  public displayableStatus: string = '?';
  public color: StatusChipColor;
  public hasSubscriptText: boolean = false;

  public ngOnChanges(): void {
    this.displayableStatus = (this.status && this.displayableStatusNames.get(this.status)) ?? this.status ?? '?';

    /*
      find() narrows down the StatusChipColors object entries to something like ['status-neutral', ['STATUS_1', 'STATUS_2']],
      so then the [0] element contains the 'status-neutral' color.
    */
    const entryContainingStatus: [string, T[]] | undefined =
      Object.entries(this.colors ?? {}).find(([, statuses]) => !!this.status && statuses.includes(this.status));

    this.color = (entryContainingStatus?.[0] as StatusChipColor) ?? 'status-inactive';

    this.hasSubscriptText = !!this.subscriptText;
  }
}
